<template>
  <div class="trade-order-block">
    <div class="block-title">门店执行信息</div>
    <div class="block-title block-sub-title">{{tradeApplyInfoVO.execTypeSubName}}</div>
    <div class="block-content">
      <!-- 图片    -->
      <!-- <el-row class="content-row">
        <el-col :span="24"
          v-viewer="{movable: true}"
          class="info-img"
        >
          <div v-if="tradeApplyExecCustom.tradeApplyExecCustomList
            && tradeApplyExecCustom.tradeApplyExecCustomList.length">
            <div
              class="img-wrapper"
              v-for="img in tradeApplyExecCustom.tradeApplyExecCustomList"
              :key="img.execCustomId"
            >
              <img :src="getImg(img.positionPhotoUri)" />
              <div class="img-wrapper-title">{{ img.positionName }}</div>
            </div>
          </div>
          <div v-else>暂无</div>
        </el-col>
      </el-row>-->
      <!-- 业务线 -->
      <el-row class="content-row">

        <BaseCell :value="tradeApplyInfoVO.clientTypeName" label="业务线" />
      </el-row>
      <!-- 业务品牌 / 子品牌      -->
      <el-row class="content-row">
        <BaseCell
          :value="
            tradeApplyExecCustom.brandName +
            ` / ${tradeApplyExecCustom.subBrandName || '暂无'}`
          "
          label=" 品牌 / 子品牌"
        />
        <BaseCell :value="tradeApplyExecCustomName" label="定制区位" />
      </el-row>
      <!-- 店招形状         店招尺寸
      要基于提报时区位有没有选店招,-->
      <el-row
        class="content-row"
        v-if="shopSignShow"
      >
        <BaseCell :value="shopSignShow.shopSignTypeName" label="店招形状"/>
        <BaseCell :value="`高：${shopSignShow.shopSignHeight}米 , 长：${shopSignShow.shopSignWidth}米`"     label="店招尺寸"/>
      </el-row>
      <!-- 店招品牌 / 子品牌 -->
       <el-row class="content-row" v-if="shopSignShow && shopSignShow.brandName">
        <BaseCell :value="shopSignShow.brandName + ` / ${shopSignShow.subBrandName||'暂无'}`" label="  店招品牌 / 子品牌" />
      </el-row>
      <!-- 区位照片 -->
      <el-row class="content-row"  v-if="urlList &&urlList.length">
        <el-col :span="3">区位照片</el-col>
        <el-col :span="21" v-viewer="{ movable: true }" class="info-img">
          <!-- 判断是否有图 -->
          <div v-if="urlList &&urlList.length">
            <div
              class="img-wrapper"
              v-for="img in urlList"
              :key="img.execCustomId"
            >
              <img :src="getImg(img.positionPhotoUri)" />
              <div class="img-wrapper-title">{{ img.positionName }}</div>
            </div>
          </div>
          <div v-else>暂无</div>
        </el-col>
      </el-row>
      <!-- 物料描述  预计投入金额 -->
      <el-row class="content-row">
        <BaseCell :value="tradeApplyExecCustom.materialDesc" label="物料描述" />
        <BaseCell
          :value="tradeApplyExecCustom.investAmount"
          label="预计投入金额"
          numberFormat
          valueUnit="元"
        />
      </el-row>
      <!-- 联系人姓名      业务员姓名 -->
      <el-row class="content-row">
        <BaseCell
          :value="tradeApplyBaseVO.keyContactPerson"
          label="联系人姓名"
        />
        <BaseCell
          :value="tradeApplyInfoVO.salesContactPerson"
          label="业务员姓名"
        />
      </el-row>
      <!--联系人电话   业务员电话  -->
      <el-row class="content-row">
        <BaseCell
          :value="tradeApplyBaseVO.keyContactPhone"
          label="联系人电话"
        />
        <BaseCell
          :value="tradeApplyInfoVO.salesContactPhone"
          label="业务员电话"
        />
      </el-row>
      <!--其它照片  -->
      <el-row class="content-row">
        <el-col :span="3">其它照片</el-col>
        <el-col :span="21" v-viewer="{ movable: true }" class="info-img">
          <div
            v-if="
              tradeApplyInfoVO.extraPhotoList &&
              tradeApplyInfoVO.extraPhotoList.length
            "
          >
            <div
              class="img-wrapper"
              v-for="img in tradeApplyInfoVO.extraPhotoList"
              :key="img.title"
            >
              <img :src="getImg(img.imageUri)" />
            </div>
          </div>
          <div v-else>暂无</div>
        </el-col>
      </el-row>
      <!-- 提报说明 -->
      <el-row class="content-row">
        <BaseCell
          :value="tradeApplyInfoVO.applyDesc"
          label="提报说明"
          allCell
        />
      </el-row>
    </div>
  </div>
</template>

<script>
import BaseCell from '@/components/base-cell'
import { commonUtils } from '@/utils/common'
import { thousandSymbol } from '@/filters'
export default {
  name: 'order-exec-cooler',
  components: {
    BaseCell
  },
  props: {
    tradeApplyBaseVO: {
      type: Object,
      default: () => {}
    },
    tradeApplyInfoVO: {
      type: Object,
      default: () => {}
    },
    tradeApplyExecCustom: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      urlList: []
    }
  },
  computed: {
    // 定制区位
    tradeApplyExecCustomName () {
      if (this.tradeApplyExecCustom?.tradeApplyExecCustomList.length) {
        let tradeApplyExecCustomList =
          this.tradeApplyExecCustom.tradeApplyExecCustomList.map((item) => {
            return item.positionName
          })
        return tradeApplyExecCustomList.join(',')
      }
      return ''
    },
    // 店招形状 店招尺寸显示
    shopSignShow () {
      let obj = null
      if (this.tradeApplyExecCustom?.tradeApplyExecCustomList.length) {
        this.tradeApplyExecCustom.tradeApplyExecCustomList.forEach(item => {
          if (item.positionCode === '50') {
            obj = {
              shopSignTypeName: item.shopSignTypeName,
              shopSignWidth: thousandSymbol(item.shopSignWidth),
              shopSignHeight: thousandSymbol(item.shopSignHeight),
              brandName: item.brandName,
              subBrandName: item.subBrandName
            }
          }
        })
      }
      return obj
    }
    // 店招品牌 /子品牌
    // brandSubBrand () {
    //   let brand = ''
    //   if (this.tradeApplyExecCustom?.tradeApplyExecCustomList.length) {
    //     this.tradeApplyExecCustom.tradeApplyExecCustomList.forEach(item => {
    //       if (item.brandName || item.subBrandName) {
    //         brand = item.brandName + ` / ${item.subBrandName || '暂无'}`
    //       } else {
    //         brand = ''
    //       }
    //     })
    //   }
    //   return brand
    // }
  },
  created () {
    this.urlList = this.tradeApplyExecCustom.tradeApplyExecCustomList.filter(item => item.positionCode !== '50')
  },
  methods: {
    getImg (uri) {
      return commonUtils.getImageUrl(uri)
    }
  }
}
</script>

<style lang="scss" scoped></style>
